import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
